// extracted by mini-css-extract-plugin
export default {"desc":"PreviewHistoryListItemSubTitle_desc__v+Pjm","descInput":"PreviewHistoryListItemSubTitle_descInput__95qR5"};